import { z } from 'zod';
const ColorSwatchSchema = z.object({
    id: z.string(),
    label: z.string(),
    hex: z.string().regex(/^#[0-9a-fA-F]{6}$/),
});
const AdditionalLayerSchema = z.object({
    layer: z.number().int(),
    part: z.string().nullable(),
    tintOptionId: z.string().optional(),
});
const CustomizationChoiceSchema = z.object({
    id: z.string(),
    label: z.string(),
    part: z.string().nullable().optional(),
    // Extra layers to set when this choice is selected, inheriting the primary layer's tint.
    additionalLayers: z.array(AdditionalLayerSchema).optional(),
});
const ShowWhenSchema = z.object({
    option: z.string(),
    not: z.string().optional(),
    in: z.array(z.string()).optional(),
    notIn: z.array(z.string()).optional(),
});
export const CustomizationOptionSchema = z.object({
    id: z.string(),
    label: z.string(),
    inputType: z.enum(['colorSwatch', 'iconSelector', 'toggleWithColor']),
    layer: z.number().int().optional(),
    mode: z.enum(['tint', 'variant', 'part', 'kit']),
    required: z.boolean(),
    part: z.string().optional(),
    palette: z.string().optional(),
    choices: z.array(CustomizationChoiceSchema).optional(),
    showWhen: ShowWhenSchema.optional(),
});
export const CharacterCustomizationConfigSchema = z.object({
    version: z.string(),
    colorPalettes: z.record(z.string(), z.array(ColorSwatchSchema)),
    options: z.array(CustomizationOptionSchema),
});
